import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _class, _descriptor;
import { computed } from "@ember/object";
import { none } from "@ember/object/computed";
import { capitalize } from "@ember/string";
import { isEmpty } from "@ember/utils";
import { Promise } from "rsvp";
import { ajax } from "discourse/lib/ajax";
import { formattedReminderTime } from "discourse/lib/bookmark";
import { longDate } from "discourse/lib/formatter";
import { applyModelTransformations } from "discourse/lib/model-transformers";
import RestModel from "discourse/models/rest";
import Topic from "discourse/models/topic";
import User from "discourse/models/user";
import getURL from "discourse-common/lib/get-url";
import discourseComputed from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
import Category from "./category";
export const AUTO_DELETE_PREFERENCES = {
  NEVER: 0,
  CLEAR_REMINDER: 3,
  WHEN_REMINDER_SENT: 1,
  ON_OWNER_REPLY: 2
};
export const NO_REMINDER_ICON = "bookmark";
export const WITH_REMINDER_ICON = "discourse-bookmark-clock";
let Bookmark = (_dec = none("id"), _dec2 = discourseComputed("highest_post_number", "url"), _dec3 = discourseComputed("bumped_at", "createdAt"), _dec4 = discourseComputed("bumpedAt", "createdAt"), _dec5 = discourseComputed("name", "reminder_at"), _dec6 = discourseComputed("created_at"), _dec7 = discourseComputed("tags"), _dec8 = computed("category_id"), _dec9 = discourseComputed("reminder_at", "currentUser"), _dec10 = discourseComputed("reminder_at"), _dec11 = discourseComputed(), _dec12 = discourseComputed("bookmarkable_type"), (_class = class Bookmark extends RestModel {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "newBookmark", _descriptor, this);
  }
  static create(args) {
    args = args || {};
    args.currentUser = args.currentUser || User.current();
    args.user = User.create(args.user);
    return super.create(args);
  }
  static createFor(user, bookmarkableType, bookmarkableId) {
    return Bookmark.create({
      bookmarkable_type: bookmarkableType,
      bookmarkable_id: bookmarkableId,
      user_id: user.id,
      auto_delete_preference: user.user_option.bookmark_auto_delete_preference
    });
  }
  static bulkOperation(bookmarks, operation) {
    const data = {
      bookmark_ids: bookmarks.mapBy("id"),
      operation
    };
    return ajax("/bookmarks/bulk", {
      type: "PUT",
      data
    });
  }
  static async applyTransformations(bookmarks) {
    await applyModelTransformations("bookmark", bookmarks);
  }
  get url() {
    return getURL(`/bookmarks/${this.id}`);
  }
  destroy() {
    if (this.newBookmark) {
      return Promise.resolve();
    }
    return ajax(this.url, {
      type: "DELETE"
    });
  }
  attachedTo() {
    return {
      target: this.bookmarkable_type.toLowerCase(),
      targetId: this.bookmarkable_id
    };
  }
  togglePin() {
    if (this.newBookmark) {
      return Promise.resolve();
    }
    return ajax(this.url + "/toggle_pin", {
      type: "PUT"
    });
  }
  pinAction() {
    return this.pinned ? "unpin" : "pin";
  }
  lastPostUrl(highestPostNumber) {
    return this.urlForPostNumber(highestPostNumber);
  }

  // Helper to build a Url with a post number
  urlForPostNumber(postNumber) {
    let url = getURL(`/t/${this.topic_id}`);
    if (postNumber > 0) {
      url += `/${postNumber}`;
    }
    return url;
  }

  // returns createdAt if there's no bumped date
  bumpedAt(bumped_at, createdAt) {
    if (bumped_at) {
      return new Date(bumped_at);
    } else {
      return createdAt;
    }
  }
  bumpedAtTitle(bumpedAt, createdAt) {
    const BUMPED_FORMAT = "YYYY-MM-DDTHH:mm:ss";
    if (moment(bumpedAt).isValid() && moment(createdAt).isValid()) {
      const bumpedAtStr = moment(bumpedAt).format(BUMPED_FORMAT);
      const createdAtStr = moment(createdAt).format(BUMPED_FORMAT);
      return bumpedAtStr !== createdAtStr ? `${I18n.t("topic.created_at", {
        date: longDate(createdAt)
      })}\n${I18n.t("topic.bumped_at", {
        date: longDate(bumpedAt)
      })}` : I18n.t("topic.created_at", {
        date: longDate(createdAt)
      });
    }
  }
  reminderTitle(name, reminderAt) {
    if (!isEmpty(reminderAt)) {
      return I18n.t("bookmarks.created_with_reminder_generic", {
        date: formattedReminderTime(reminderAt, this.currentUser?.user_option?.timezone || moment.tz.guess()),
        name: name || ""
      });
    }
    return I18n.t("bookmarks.created_generic", {
      name: name || ""
    });
  }
  createdAt(created_at) {
    return new Date(created_at);
  }
  visibleListTags(tags) {
    if (!tags || !this.siteSettings.suppress_overlapping_tags_in_list) {
      return tags;
    }
    const title = this.title;
    const newTags = [];
    tags.forEach(function (tag) {
      if (!title.toLowerCase().includes(tag)) {
        newTags.push(tag);
      }
    });
    return newTags;
  }
  get category() {
    return Category.findById(this.category_id);
  }
  formattedReminder(bookmarkReminderAt, currentUser) {
    return capitalize(formattedReminderTime(bookmarkReminderAt, currentUser?.user_option?.timezone || moment.tz.guess()));
  }
  reminderAtExpired(bookmarkReminderAt) {
    return moment(bookmarkReminderAt) < moment();
  }
  topicForList() {
    // for topic level bookmarks we want to jump to the last unread post URL,
    // which the topic-link helper does by default if no linked post number is
    // provided
    const linkedPostNumber = this.bookmarkable_type === "Topic" ? null : this.linked_post_number;
    return Topic.create({
      id: this.topic_id,
      fancy_title: this.fancy_title,
      linked_post_number: linkedPostNumber,
      last_read_post_number: this.last_read_post_number,
      highest_post_number: this.highest_post_number
    });
  }
  bookmarkableTopicAlike(bookmarkable_type) {
    return ["Topic", "Post"].includes(bookmarkable_type);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "newBookmark", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "url", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "url"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lastPostUrl", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "lastPostUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bumpedAt", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "bumpedAt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bumpedAtTitle", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "bumpedAtTitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reminderTitle", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "reminderTitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "createdAt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "visibleListTags", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "visibleListTags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "category", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "category"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedReminder", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "formattedReminder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reminderAtExpired", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "reminderAtExpired"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "topicForList", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "topicForList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "bookmarkableTopicAlike", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "bookmarkableTopicAlike"), _class.prototype)), _class));
export { Bookmark as default };